import React from 'react'

import * as S from './styled'
import type { InnerFieldProps } from './types'

export const InnerField = ({ fluid = false, children }: InnerFieldProps) => {
  return <S.Container $fluid={fluid}>{children}</S.Container>
}
